import { useConfig } from "@/context/ConfigContext";
import { isRobinhoodEcosystemEnabled } from "@/lib/robinhoodFlags";
import RobinhoodEcosystemPage from "@/pages/RobinhoodEcosystemPage";
import NotFoundPage from "@/pages/NotFoundPage";

/** Route gate: build-time env OR backend /api/config flag. */
export default function RobinhoodEcosystemGate() {
  const config = useConfig();
  if (config == null) {
    return <div className="min-h-screen bg-black" data-testid="rh-ecosystem-loading" aria-hidden />;
  }
  if (!isRobinhoodEcosystemEnabled(config)) {
    return <NotFoundPage title="Robinhood ecosystem unavailable" />;
  }
  return <RobinhoodEcosystemPage />;
}
